// Home Getters

export const homepageLinks = state => {
  return state.homepageLinks
}
